import EkiDown from '@/App/tiles/TargetAccumulator/Schedule/EkiDown.tsx';
import EkiTrigger from '@/App/tiles/TargetAccumulator/Schedule/EkiTrigger.tsx';
import EkiUp from '@/App/tiles/TargetAccumulator/Schedule/EkiUp.tsx';
import FixingDate from '@/App/tiles/TargetAccumulator/Schedule/FixingDate.tsx';
import Leverage from '@/App/tiles/TargetAccumulator/Schedule/Leverage.tsx';
import Notional from '@/App/tiles/TargetAccumulator/Schedule/Notional.tsx';
import PaymentDate from '@/App/tiles/TargetAccumulator/Schedule/PaymentDate.tsx';
import Pivot from '@/App/tiles/TargetAccumulator/Schedule/Pivot.tsx';
import DeleteIcon from '@/App/tiles/TargetAccumulator/Schedule/ScheduleHeader/DeleteIcon.tsx';
import Strike from '@/App/tiles/TargetAccumulator/Schedule/Strike.tsx';
import StrikeDown from '@/App/tiles/TargetAccumulator/Schedule/StrikeDown.tsx';
import StrikeUp from '@/App/tiles/TargetAccumulator/Schedule/StrikeUp.tsx';
import type { SchedulerCalendarProperty } from '@/store/targetAccumulator/utils.ts';

const DataCellRenderer = ({ property, legId }: { property: SchedulerCalendarProperty; legId: string }) => {
  switch (property) {
    case 'amount':
      return <Notional legId={legId} />;
    case 'fixingDate':
      return <FixingDate legId={legId} />;
    case 'leverageAmount':
      return <Leverage legId={legId} />;
    case 'paymentDate':
      return <PaymentDate legId={legId} />;
    case 'strike':
      return <Strike legId={legId} />;
    case 'PIVOT':
      return <Pivot legId={legId} />;
    case 'strikeDown':
      return <StrikeDown legId={legId} />;
    case 'strikeUp':
      return <StrikeUp legId={legId} />;
    case 'ekiDown':
      return <EkiDown legId={legId} />;
    case 'ekiUp':
      return <EkiUp legId={legId} />;
    case 'EKI':
      return <EkiTrigger legId={legId} />;
    case 'deleteIcon':
      return <DeleteIcon legId={legId} />;
    default:
      return null;
  }
};

export default DataCellRenderer;
